import { GoalSortingMode, rootId } from '@griply/types';
import { GoalReorderSectionUpdate, UpdateGoal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type LifeAreaTimelineReorder = {
  goalUpdates: UpdateGoal[];
  lifeAreaGoalSorting: ID[] | null;
};

// Re-attaching the life area is the caller's job: it reads the resolver's parent changes, so a
// goal that kept another parent is not handed a life area it never asked for.
export const resolveLifeAreaTimelineReorder = (
  updatedSections: GoalReorderSectionUpdate[],
  updatedGoals: UpdateGoal[],
): LifeAreaTimelineReorder => {
  // getGoalListOrder honors goalSorting only in Custom mode.
  const goalUpdates = updatedGoals.map((update) =>
    update.goalSorting === undefined
      ? update
      : { ...update, goalSortingMode: GoalSortingMode.Custom },
  );

  const rootSection = updatedSections.find(({ id }) => id === rootId);

  return { goalUpdates, lifeAreaGoalSorting: rootSection?.goalSorting ?? null };
};
